export default __webpack_public_path__ + "assets/add_big.png";